export class Splash {
    constructor() {
        this.splash = document.querySelector(".splash");
        this.fueCerrado = false;

        if (!this.splash) return;

        this.splash.addEventListener("click", this.cerrar.bind(this));
        document.querySelector(".splash .splash__cerrar").addEventListener("click", this.cerrar.bind(this));
    }

    cerrar() {
        if (!this.splash) return;

        if (this.splash.classList.contains("visible")) {
            this.splash.classList.remove("visible");
        }

        this.fueCerrado = true;
    }

    abrir() {
        if (!this.splash) return;

        if (this.fueCerrado) return;

        // this.splash.classList.add("visible");

        let ahora = new Date().getTime();
        let fueAbierto = localStorage.getItem('splash');

        if (fueAbierto === null) {
            //Guardo en localStorage fecha de apertura
            let obj = {fecha: ahora};
            localStorage.setItem('splash', JSON.stringify(obj));
            this.splash.classList.add("visible");

            return;
        }

        let obj = JSON.parse(fueAbierto);

        //Sí pasaron 1 día desde la última apertura
        if (ahora - obj.fecha > 86400000) {
            //Guardo en localStorage fecha de apertura
            obj.fecha = ahora;
            localStorage.setItem('splash', JSON.stringify(obj));
            this.splash.classList.add("visible");
        }
    }
}
